import React from 'react';
import { contains, is, path, forEachObjIndexed } from 'ramda';
import { Field } from 'react-final-form';
import Translate from 'react-translate-component';

import InputHidden from 'components/common/form/InputHidden';

const fieldsToSkip = [
    'CANDNAME',
    'INTDATE',
    'POSNAME',
    'ZAKNAME',
    'CAND',
    'CANDKEY',
    'REKR',
    'REKRKEY',
    'type',
    'fileType',
    'xmlbody',
    'CandKey',
    'SotrName',
    'Candidate',
    'IntDate',
    'SotrKey',
    'body',
    'Employee',
    'REKOMFIO',
    'REKOMCOMP',
    'WHOCREATEKEY',

    'resultType',
    'xmlType',
];

const sumSymbols = (values) => {
    let result = 0;
    forEachObjIndexed((value, key) => {
        if (contains(key.toString().trim(), fieldsToSkip)) {
            return;
        }

        if (is(String, value)) {
            result += value.toString().trim().length;
        } else {
            result += sumSymbols(value);
        }
    }, values);
    return result;
}

const validateSymbolCount = (min, values) => {
    if (min === 0) return undefined;
    const currentCount = sumSymbols(path(['result'], values)) + sumSymbols(path(['result', 'xmlbody'], values));
    return currentCount < min ? <Translate content="errors.notEnoughSymbols" with={{ min, currentCount }} /> : undefined;
};

const ValidateCountField = ({ minSymbols, ...rest }) => (
    <Field
        {...rest}
        name='validateCount'
        inputValue={parseInt(minSymbols, 10)}
        style={{ height: '40px' }}
        validate={validateSymbolCount}
        component={InputHidden}
        notWrap={true}
    />
);

export default ValidateCountField;
